module.exports = __webpack_public_path__ + "static/media/33000144.72ed8a66.jpg";